import { NgStyle } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CartStore } from '@apps/mtjr/customers/app/cart/cart.store';
import {
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonMenuButton,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ApiService } from '@libs/core/base-config';
import { shareCart } from '@libs/mtjr/shared/generated/entities/shared-cart/service/shared-cart.service';
import { Dtos } from '@libs/mtjr/shared/generated/types';

import { VxCurrencyPipe } from '@libs/core/lib/pipes/mtjr-currency.pipe';
import { VxDynamicImageComponent, VxImageComponent } from '@libs/core/lib/shared/mtjr-image.component';
import { AppAlerts } from '@libs/core/lib/utils/app-alerts';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mac-cart',
  imports: [
    IonLabel,
    IonContent,
    IonList,
    IonText,
    IonButton,
    IonIcon,
    VxCurrencyPipe,
    IonCard,
    IonHeader,
    IonCard,
    IonToolbar,
    IonTitle,
    IonButtons,
    RouterLink,
    VxDynamicImageComponent,
    TranslatePipe,
    NgStyle,
    IonMenuButton,
    RouterLink,
    VxImageComponent,
  ],
  templateUrl: './cart.page.html',
})
export class CartPage {
  cartStore = inject(CartStore);
  appAlerts = inject(AppAlerts);
  translate = inject(TranslateService);
  apiService = inject(ApiService);
  isSharing = false;

  async clear() {
    const confirm = await this.appAlerts.yesNoAlertTR({
      header: 'CART.CLEAR',
      message: 'CART.CLEAR_CONFIRM',
      yesCaption: 'CART.CLEAR',
      role: 'destructive',
    });
    if (confirm) this.cartStore.reset();
  }

  async shareCartHandler() {
    if (this.isSharing || !this.cartStore.items().length) return;

    this.isSharing = true;
    try {
      const items: Dtos.SharedCartItem[] = this.cartStore.items().map((item) => ({
        productId: item.product.id,
        variantId: item.variation?.id,
        quantity: item.quantity,
      }));

      const response = await new Promise<Dtos.ShareCartResponse>((resolve, reject) => {
        shareCart(this.apiService, { items }).subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(err),
        });
      });

      const shareUrl = `${window.location.origin}/#/shared-cart/${response.id}`;

      if (navigator.share) {
        await navigator.share({
          title: this.translate.instant('CART.SHARE_CART'),
          url: shareUrl,
        });
      } else {
        await navigator.clipboard.writeText(shareUrl);
        await this.appAlerts.successSnackbarTR('CART.SHARE_LINK_COPIED');
      }
    } catch (error) {
      console.error('Error sharing cart:', error);
      await this.appAlerts.dangerSnackbarTR('CART.SHARE_ERROR');
    } finally {
      this.isSharing = false;
    }
  }
}
